import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import LocationList from './LocationList';

class LocationListContainer extends Component {
  componentDidMount() {
    this.props.fetchLocationsIfNeeded();
  }

  render() {
    const { ui } = this.props;
    return (
      <LocationList
        locations={this.props.allLocations}
        isEditable={this.props.isEditable}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ui: selectors.getUI,
  allLocations: selectors.getOrdered
});

export default connect(mapStateToProps, actions)(LocationListContainer);



// WEBPACK FOOTER //
// ./src/modules/locations/components/LocationListContainer.js